import styled from 'vue-styled-components'

const FrameProps = {
  headerActive: false,
}
const FloatframeHover = styled('div', FrameProps)`
  pointer-events: auto;
  position: absolute;
  width: max-content;
  white-space: nowrap;
  padding: 2px 12px 0px;
  font-family: 'Roboto';
  font-size: 12px;
  line-height: 12px;
  bottom: ${({headerActive}) => headerActive ? '-16px': '100%'};
  left: 0;
  z-index: 3;
/* border-radius: 0px 0px 4px 0px; */
  color: #12A9FF;
  background-color: #F4FCFF;
  border: 1px solid #ADDFFC;
  height: max-content;
`


// const SectionNameHover = css`
// color: #12A9FF;
// background-color: #F4FCFF;
// border: 1px solid #12A9FF;
// `
// const SectionNameActive = css`
// color: white;
// background-color: #999999;
// border: 1px solid #999999;
// `
// const OverlayHover = css`
//   opacity: 0.8;
//   transition: all 0.3s ease;
//   cursor: pointer;
//   background-color: #00000012;
// `;
// const FloatframeHover = styled.div`
//  pointer-events: auto;
// position: absolute;
// width: max-content;
// white-space: nowrap;
// padding: 2px 12px 0px;
// font-family: 'Roboto';
// font-size: 12px;
// line-height: 12px;
// left: 0;
// z-index: 3;
// /* border-radius: 0px 0px 4px 0px; */
// color: #12A9FF;
// background-color: #F4FCFF;
// border: 1px solid #ADDFFC;
// bottom: 100% ;
// &.hover:not(.active) {
//     & > .lbl-name, & > .add-section, & > .section-tool{
//       opacity: 1;
//       transition: all 0.3s ease;
//     }
//     & > .overlay {
//       ${OverlayHover}
//     }
//     & > .lbl-name {
//       ${SectionNameHover}
//     }
   
//   }
//   &.hover, &.active {
//     & > .lbl-name[lv="0"], & > .add-section,  & > .section-tool{
//       opacity: 1;
//       transition: all 0.3s ease;
//     }
//   }
//   &.active {
//     & > .lbl-name {
//       ${SectionNameActive}
//     }
//     & > .add-section{
//       opacity: 0;
//       transition: all 0.1s ease;
//     }

//   }
// `
const SectionName = styled.div`
  position: absolute;
  width: max-content;
  white-space: nowrap;
  padding: 5px;
  border-radius: 0px 5px 0px 0px;
  color: #12A9FF;
  left: 0;
  background-color: #F4FCFF;
  opacity: 0;
  z-index: 4;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 12px;
  border: 1px solid #12A9FF;

`
const AddSection = styled.div`
  &.top {
    top: calc( 30px / -2 );
  }
  &.bottom {
    bottom: calc( 30px / -2 );
  }
  opacity: 20;
  position: absolute;
  /* background-color: #12A9FF; */
  background-color: #12A9FF;
  
  left: 0;
  right: 0;
  margin: auto;
  z-index:999;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
`


const WrapperProps = {
  position: {}
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 6;
.icon-hover-label {
  pointer-events: auto;
}
&::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: 2px solid #C3E9FF;
  // background-color: rgba(244,252,255, 0.3);
  z-index: 4;
}
&.active {

    & > .add-section{
      opacity: 0;
      transition: all 0.1s ease;
    }

  }
/* border: 3px solid red; */

.lbl-name {
  bottom: 100%;
  border-bottom: 0px;
}

&.top {
  .lbl-name {
    bottom: 100%;
    border-bottom: 0px;
  }
}
&.bottom {
  .lbl-name {
    top: 100%;
    border-top: 0px;
  }
}

`

export {
  FloatframeHover,
  SectionName,
  AddSection,
  Wrapper
}